import styled from "styled-components";
import zIndexTypes from "../../../../theme/zIndexTypes";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const MessageFormWrapper = styled.div`
  z-index: ${zIndexTypes.datePickerPopup};
  width: 650px;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  flex: 0 0 auto;

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 20px);
  `}
`;

export const Form = styled.form`
  margin: 0 auto;
  position: relative;
  height: 100%;

  button {
    margin-top: 0;
  }

  ${mediaMaxWidth.phone`
    width: 100%;
  `}
`;

export const ActionsButton = styled.div`
  display: flex;
  text-align: left;
  font-weight: 700;
  width: 160px;
  padding: 15px 15px 5px 15px;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #f2008c;
  }

  svg {
    position: relative;
    top: 3px;
    font-size: 0.9em;
    left: 6px;
  }

  ${mediaMaxWidth.phone`
    width: 140px;
    padding: 7px 5px 5px 10px;
    font-size: 0.9em;
  `}

  ${mediaMaxWidth.smallPhone`
    padding: 7px 5px 5px 5px;
    font-size: 0.75em;
  `}
`;

export const ActionsList = styled.div`
  position: absolute;
  bottom: 100px;
  background: #fff;
  width: 300px;
  text-align: left;
  border-radius: 4px;
  box-shadow: 0 0 5px #d6d6d6;
  opacity: 0;
  transition: 0.15s ease-in-out;
  left: -300px;
  padding: 10px;

  &::after,
  &::before {
    top: 100%;
    left: 50px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: #ffffff;
    border-width: 6px;
    margin-left: 0px;
  }
  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-top-color: #edebeb;
    border-width: 8px;
    margin-left: -2px;
  }

  &.shown {
    left: -10px;
    opacity: 1;

    ${mediaMaxWidth.phone`
      left: 0;
    `}
  }

  ${mediaMaxWidth.phone`
    width: 250px;
    bottom: 80px;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 220px;
  `}
`;

export const Option = styled.input`
  margin: 2px 0;
  display: none;
`;

export const Label = styled.label`
  display: block;
  font-weight: 500;
  margin: 0px 0;
  padding: 7px 10px;
  cursor: pointer;
  transition: 0.05s ease-in-out;

  &:hover {
    background: #f2008c;
    color: #fff;
    border-radius: 4px;
  }

  ${mediaMaxWidth.phone`
    font-size: 0.9em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.8em;
  `}
`;

export const SelectedAction = styled.div`
  margin: 0;
  border: 1px solid;
  border-radius: 4px;
  text-transform: capitalize;
  font-size: 0.85em;
  font-weight: 700;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 4px;
  padding: 4px 25px;
  position: absolute;
  left: 160px;
  top: 9px;
  min-width: 240px;
  display: ${(props) => (props.active ? null : "none")};

  ${mediaMaxWidth.phone`
    padding: 4px 15px 4px 5px;
    font-size: 0.65em;
    left: 135px;
    min-width: 170px;
    top: 5px;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.6em;
    left: 115px;
    min-width: 160px;
  `}

  &::before {
    content: "•";
    color: #333;
    font-size: 3.1em;
    position: absolute;
    top: -17px;
    left: 5px;
    height: 5px;

    ${mediaMaxWidth.phone`
      display: none;
    `}
  }
`;

export const RemoveAction = styled.span`
  padding: 0 0 0 10px;
  cursor: pointer;

  &::after {
    content: "✖";
    font-size: 1.37em;
    position: absolute;
    font-weight: 700;
    top: 0px;
    right: 7px;
    transition: 0.1s ease-in-out;

    ${mediaMaxWidth.phone`
      top: 2px;
    `}
  }

  &:hover {
    &::after {
      color: #f2008c;
    }
  }
`;

export const TextInput = styled.input`
  width: 405px;
  height: 35px;
  border: none;
  outline: none;
  padding: 0 15px;
  position: relative;
  bottom: 0;

  ::-webkit-input-placeholder {
    color: #333;
    font-size: 1.1em;
  }
  ::-moz-placeholder {
    color: #333;
    font-size: 1.1em;
  }
  :-ms-input-placeholder {
    color: #333;
    font-size: 1.1em;
  }
  :-moz-placeholder {
    color: #333;
    font-size: 1.1em;
  }

  ${mediaMaxWidth.phone`
    width: 75vw;
    padding: ${(props) => (props.iOS ? "0 8px" : "0")};
    font-size: 0.9em;
  `}

  ${mediaMaxWidth.phone`
    font-size: 0.75em;
  `}
`;

export const SendButton = styled.input`
  background: none;
  border: none;
  color: #f2008c;
  font-weight: 700;
  transition: 0.2s ease-in-out;

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    color: #673490;
  }
`;
